import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import SeekerConfigListing from './SeekerConfigListing';
import SeekerCredentialsForm from './SeekerCredentialsForm';

const SeekerPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={SeekerCredentialsForm}
        PullConfigListingView={SeekerConfigListing}
     />
);

export default SeekerPullAndPushView;
